import React from "react";
import { Search } from "lucide-react";

export function UserFilters({
  search, setSearch,
  orgFilter, setOrgFilter,
  roleFilter, setRoleFilter,
  organizations,
}) {
  return (
    <div className="flex flex-wrap gap-3">
      <div className="relative flex-1 min-w-[200px]">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
        <input
          type="text"
          placeholder="Buscar..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="w-full pl-10 pr-4 py-2 bg-slate-800 border border-slate-700 rounded-lg text-white"
        />
      </div>
      <select
        value={orgFilter}
        onChange={(e) => setOrgFilter(e.target.value)}
        className="px-3 py-2 bg-slate-800 border border-slate-700 rounded-lg text-white"
      >
        <option value="">Todas las organizaciones</option>
        {organizations.map((org) => (
          <option key={org.organization_id} value={org.organization_id}>
            {org.name}
          </option>
        ))}
      </select>
      <select
        value={roleFilter}
        onChange={(e) => setRoleFilter(e.target.value)}
        className="px-3 py-2 bg-slate-800 border border-slate-700 rounded-lg text-white"
      >
        <option value="">Todos los roles</option>
        <option value="superadmin">Superadmin</option>
        <option value="owner">Owner</option>
        <option value="admin">Admin</option>
        <option value="compliance_officer">Cumplimiento</option>
        <option value="capturista">Capturista</option>
      </select>
    </div>
  );
}
